import { Loading } from '@byecode/ui'
import type { Workflow, WorkflowType } from '@lighthouse/shared'
import { WorkflowRunType } from '@lighthouse/shared'
import React, { useMemo } from 'react'
import useSWR from 'swr'

import type { FlowDetailShape } from '@/contexts/FlowContext'
import * as srv from '@/services'

import { FlowEditor } from '../FlowDetail/FlowEditor'

interface FlowLogDetailProps {
    id: string
    name: string
    type: WorkflowType

    shape: FlowDetailShape
    onBack?: () => void
    onClose?: () => void
}

export const FlowLogDetail: React.FC<FlowLogDetailProps> = ({ id, name, type, shape, onClose }) => {
    const { data: flowDetail, isLoading } = useSWR(
        id,
        async () => {
            if (!id) {
                return
            }

            return await srv.getFlowLog(id)
        },
        {
            revalidateOnFocus: false
        }
    )

    const data: Workflow | undefined = useMemo(() => {
        if (!flowDetail) {
            return
        }
        return {
            id,
            content: flowDetail.content,
            name,
            type,
            runType: WorkflowRunType.PARALLEL,
            unConfigured: false,
            enabled: true
        }
    }, [flowDetail, id, name, type])

    if (isLoading) {
        return <Loading />
    }

    if (!data) {
        return null
    }

    return <FlowEditor name={name} log={flowDetail} data={data} shape={shape} onClose={onClose} />
}
